import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router";
// Components
import Footer from 'components/presentational/Footer';
import ReplaySection from 'components/presentational/ReplaySection';
import BeneficiarySVG from 'components/svg/BeneficiarySVG.js';
import GTMPush from 'components/GTMPush'
// Functions
import {
    setSectionAsAnimated,
    setAudioToPlay,
    incrementAudioPlayCount,
    stopAudio
} from 'redux/actions';

import animation from './animation.js';
// Files
import './beneficiary.scss';

const mapStateToProps = state => {
    return {
        volumeIsOn: state.volumeIsOn,
        animatedSections: state.animatedSections,
        userInteracted: state.userInteracted,
        navMethodGTM: state.gtm.navMethod
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSectionAsAnimated: (val) => dispatch(setSectionAsAnimated(val)),
        setAudioToPlay: (audioKey) => dispatch(setAudioToPlay(audioKey)),
        incrementAudioPlayCount: () => dispatch(incrementAudioPlayCount()),
        stopAudio: () => dispatch(stopAudio())
    };
};

class ConnectedBeneficiary extends Component {
    constructor() {
        super();
        this.audio = React.createRef();
        // Bindigs
        this.handleReplayClick = this.handleReplayClick.bind(this);
        this.playAudio = this.playAudio.bind(this);
    }

    componentDidMount() {
        if (this.props.userInteracted && !this.props.animatedSections.some(el => el === this.props.id)) {
            this.animateSection();
        } else {
            // This will fire if we went back a page. If so, stop the current audio from playing.
            this.props.stopAudio();
        }
    }

    componentWillUpdate(nextProps) {
        if (nextProps.userInteracted && !this.props.userInteracted) {
            this.animateSection();
        }
    }

    componentWillUnmount() {
        this.props.setSectionAsAnimated(this.props.id);
    }

    playAudio() {
        this.props.setAudioToPlay('Beneficiary');
        this.props.incrementAudioPlayCount();
    }

    animateSection() {
        animation(this.playAudio);
    }

    handleReplayClick() {
        this.animateSection();
    }

    render() {
        return (
            <div className="beneficiary">
            
                <GTMPush 
                  event="pageLoad" 
                  virtualPath={this.props.location.pathname} 
                  pageNo="01" 
                  pageName={this.props.pageName} 
                  quizAnswer="undefined" />
                
                <div className="container">
                    <div className="row">
                        <div className="col-one-half">
                            <h1 className="heading-2 beneficiary__heading heading-1">For the beneficiary</h1>

                            <div className="beneficiary__content">
                                <p>The beneficiary is the person named to receive the proceeds from the insurance policy. If you’re here because you’re assisting the beneficiary, be sure to inform them of any steps you take on their behalf.</p>

                                <p>We’ll walk you through four simple steps to receiving your benefits, including what paperwork you’ll need and how to get the proceeds from the policy.</p>

                                <p>If you have any questions, call us at <strong className="no-line-break">1-800-MET-6420 (638&#8209;6420), prompt 2</strong>.</p>
                            </div>
                        </div>

                        <div className="col-one-half">
                            <div className="beneficiary__image">
                                <BeneficiarySVG className="image" />
                            </div>

                        </div>
                    </div>
                    
                    <ReplaySection handleClick={this.handleReplayClick}/>
                </div>

                <Footer pageIndex={1}/>
            </div>
        )
    }
}

const Beneficiary = connect(mapStateToProps, mapDispatchToProps)(ConnectedBeneficiary);

export default withRouter(Beneficiary)
